"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _ProductIcon = _interopRequireDefault(require("./ProductIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var productManifest = state.productManifest;
  var iconFileName = ownProps.iconFileName;
  var size = ownProps.size || 48;
  return {
    productManifest: productManifest,
    iconFileName: iconFileName,
    size: size
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_ProductIcon["default"]);